























































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Buildings extends Vue {
  get factions() {
    return [...this.$store.state.data.players.map((p) => p.faction).filter((f) => !!f), "gen"];
  }
}
